import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, watch, onMounted } from "vue";
import UrlConstants from "@/utils/urlconstants";
import commonModule from "@/composables/modules/commonModule";

export default /*@__PURE__*/_defineComponent({
  __name: 'commonFileUpload',
  props: {
    accept: { type: String, default: "image/*" },
    multiple: { type: Boolean, default: false },
    auto: { type: Boolean, default: false },
    maxFileSize: { type: Number, default: null },
    fileLimit: { type: Number, default: null },
    chooseIcon: { type: Boolean, default: true },
    showUploadButton: { type: Boolean, default: false },
    chooseLabel: { type: String, default: "Browse Files" },
    previewWidth: { type: Number, default: 10 },
    modelValue: [String, File],
    name: { type: String, required: true, },
    propname: { type: String, required: false, },
    v$: Object,
    Isdisabled: { type: Boolean, default: false },
    AfterSelectFile: { type: Function, default: null },
    callBack: Function,
    downloadurl: { type: String, default: "" },

},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { GetFile } = new commonModule();
const emit = __emit;
const InputValue = ref();
let Props = __props;
const FileUploadCtrl = ref();
const UploadedFiles = ref([]);
const ErrorFiles = ref([]);
const onSelectFile = (event: any) => {
    UploadedFiles.value = event.files;
    emit("update:modelValue", Props.multiple ? event.files : event.files[0]);
    if (Props.AfterSelectFile)
        Props.AfterSelectFile(Props.multiple ? event.files : event.files[0]);
    if (Props.multiple) {
        ErrorFiles.value = []
        if ((FileUploadCtrl?.value?.messages || []).length > 0) {
            ErrorFiles.value = (FileUploadCtrl?.value?.messages || [])
            FileUploadCtrl.value.messages = []
        }
    }
}
const onRemoveFile = (index: number, Id: number) => {
    if (!Props.multiple) {
        FileUploadCtrl.value.files = [];
        UploadedFiles.value = [];
        emit("update:modelValue", null);
        if (Props.AfterSelectFile)
            Props.AfterSelectFile({ name: "" });
    }
    else {
        if (Id > 0) {
            index = FileUploadCtrl.value.files.findIndex(x => x.Id == Id);
        }
        else {
            index = FileUploadCtrl.value.files.findIndex(x => x == FileUploadCtrl.value.files.filter(y => !('IsDeleted' in y) || !y.IsDeleted)[index]);
        }
        if (FileUploadCtrl.value.files[index].Name)
            FileUploadCtrl.value.files[index].IsDeleted = true;
        else
            FileUploadCtrl.value.files.splice(index, 1);
        UploadedFiles.value = FileUploadCtrl.value.files;
        emit("update:modelValue", UploadedFiles.value);
    }
    if (typeof Props.callBack != "undefined") {
        Props.callBack('');
    }
}
const updateValue = (val: any) => {
    if (Props.multiple)
        UploadedFiles.value = val ? val : [];
    else {
        UploadedFiles.value = [];
        if (val) {
            UploadedFiles.value.push(val);
        }
    }
    FileUploadCtrl.value.files = UploadedFiles.value;
}
onMounted(() => {
    updateValue(Props.modelValue);
});

watch(() => Props.modelValue, () => {
    if (Props.multiple) {
        ErrorFiles.value = []
    }
    updateValue(Props.modelValue);
});

const downloadFile = (itm: any) => {
    if ((itm?.Id ?? 0) > 0 && (Props?.downloadurl ?? "").length > 0) {
        if ((itm?.FileName ?? "").length > 0) {
            GetFile(`${(Props?.downloadurl ?? "")}${itm?.FileName ?? ""}`, (data: any) => {
                const blob = new Blob([data])
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = itm.name ?? itm.Name
                link.click()
                URL.revokeObjectURL(link.href)
            });
        }
    }
}

const __returned__ = { GetFile, emit, InputValue, get Props() { return Props }, set Props(v) { Props = v }, FileUploadCtrl, UploadedFiles, ErrorFiles, onSelectFile, onRemoveFile, updateValue, downloadFile }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})